document.body.addEventListener("click", (e) => {
	if (e.target.classList.contains("expCollapse")) {
		e.target.closest(".collection-hero__description").classList.toggle("exp");
		e.preventDefault();
	}
});
